// extracted by mini-css-extract-plugin
export default {"container":"summary-bar__container___oJBXp","label":"summary-bar__label___28ykI","icon":"summary-bar__icon___Uyd44","icon-loading":"summary-bar__icon-loading___15SVe"};